// ///storage constant
///const { host } = window.location
export default {
    STORAGE_URL: "https://storage.oms.innovate10x.com",
    SERVERS_URL: "https://oms-servers.oms.innovate10x.com/OMS-SERVERS-LIST",
    DEV_URL: "dev10-web.oms.innovate10x.com",
    MEDIA_PREFIX: "scanned-media-prefix"
}
